import { app } from 'app/app';
import { AppController } from 'app/controller';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';
import { mediaQueries } from 'util/mediaQueries';
import { MasterLayout } from 'layout/master/main';
import { JobDetailContent } from 'module/jobDetailContent/main';
import { hasConsentGrantedOrDenied, onConsentChange } from 'util/consent';
import './styles.scss';

class JobDetail extends AppController {
    ready() {
        this.initHistoryApi();
        this.sendAdWordsTracking();
        this.sendShowEvents();
    }

    onPopState(state) {
        if (!state) return; // hashbang fix
        const shareModalActive = state.shareModalOpen ? state.shareModalOpen : false;

        if (mediaQueries.isMobile()) {
            if (shareModalActive) {
                this.jobDetail.openShareModal();
            } else if (this.jobDetail.isShareModalOpen()) {
                this.jobDetail.closeShareModal();
            }
        }
    }

    domBindings() {
        return {
            jobDetail: '.m-jobDetailContent',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.jobDetail = new JobDetailContent(this.dom.jobDetail);
    }

    subEvents() {
        if (hasConsentGrantedOrDenied()) {
            this.jobDetail.allowPointerEvents();
        }
        onConsentChange(() => {
            if (hasConsentGrantedOrDenied()) {
                this.jobDetail.allowPointerEvents();
            }
        });
        if (this.dom.jobDetail) {
            this.jobDetail.events.on('toggleContent', () => {
                this.toggleContent();
            });

            this.jobDetail.events.on('pushState', () => {
                const props = { ...this.getProps() };
                props.shareModalOpen = true;
                this.pushState(props, document.title, window.location.href);
            });

            this.jobDetail.events.on('addShareModalStyles', () => {
                this.layout.addModalStyle();
                window.document.querySelector('.c-jobDetail')
                    .classList.add('c-jobDetail--openModal');
            });

            this.jobDetail.events.on('removeShareModalStyles', () => {
                this.layout.removeModalStyle();
                window.document.querySelector('.c-jobDetail')
                    .classList.remove('c-jobDetail--openModal');
            });

            this.jobDetail.events.on('addModalStyle', () => {
                this.layout.addModalStyle();
            });

            this.jobDetail.events.on('removeModalStyle', () => {
                this.layout.removeModalStyle();
            });
        }
        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true, true);
            });
        }
    }

    toggleContent() {
        this.jobDetail.render();
    }

    sendShowEvents() {
        if (this.jobDetail) this.jobDetail.sendShowEvents();
    }

    sendAdWordsTracking() {
        window.dataLayer.push({
            googleAdsData: {
                job_pagetype: 'offerdetail',
                job_id: this.jobDetail.props.jobContent.id,
            },
        });
    }
}

app.boot(JobDetail);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(JobDetail);
    });

    module.hot.accept(() => {});
}
